import React, { useRef, useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import Particles from "react-tsparticles";

import classes from './Snaplark.module.scss';
import VideoPlayer from '../../../UI/VideoPlayer/VideoPlayer';
import BigButton from '../../../UI/BigButton/BigButton';

const getVideoWidth = ()=> window.innerWidth >= 875 ? window.innerWidth * 0.48 : window.innerWidth * 0.7;

const dots = [];
for (let i=0; i<Math.max(4, window.innerWidth / 80); i++) {
  dots.push({
    size: Math.random() * 5 + 5,
    x: Math.random() * (window.innerWidth - 40) + 20,
    y: Math.random() * (window.innerHeight - 40) + 20
  });
}

const Snaplark = ({ colors, end, className, style }) => {
  const [videoWidth, setVideoWidth] = useState(getVideoWidth());
  // const [scrollable, setScrollable] = useState( window.innerWidth >= 875 ? false : true);
  // const [videoShow, setVideoShow] = useState(true);
  const videoContainerRef = useRef();

  useEffect(() => {
    const resizeHandler = ()=> {
      // const width = videoContainerRef.current.getBoundingClientRect().width;
      setVideoWidth(getVideoWidth());
      // if (window.innerWidth > 875 && scrollable) setScrollable(false);
      // else if (window.innerWidth <= 875 && !scrollable) setScrollable(true);
    }
    window.addEventListener('resize', resizeHandler);
    return ()=> window.removeEventListener('resize', resizeHandler);
  }, []);

  const rootClass = [classes.Snaplark];
  if (className) rootClass.push(className);
  // if (scrollable) rootClass.push('scrollable');

  return (
    <div className={rootClass.join(' ')} style={style ? style:{}}
    >
      {dots.map((dot, i) => (
        <span key={i} className={classes.Dot} style={{
          width: dot.size,
          height: dot.size,
          left: dot.x,
          top: dot.y
        }} ></span>
      ))}
      <Particles
        id="tsparticles"
        className={classes.Particles}
        options={{
          fpsLimit: 60,
          interactivity: {
            // detectsOn: "canvas",
            // events: {
            //   onClick: {
            //     enable: true,
            //     mode: "push",
            //   },
            //   onHover: {
            //     enable: true,
            //     mode: "repulse",
            //   },
            //   resize: true,
            // },
            modes: {
              bubble: {
                distance: 400,
                duration: 2,
                opacity: 0.8,
                size: 40,
              },
              push: {
                quantity: 4,
              },
              repulse: {
                distance: 200,
                duration: 0.4,
              },
            },
          },
          particles: {
            color: {
              value: "#ffffff",
            },
            move: {
              direction: "top",
              enable: true,
              outMode: "bounce",
              random: false,
              speed: 1,
              straight: false,
            },
            rotate: {
              direction: 'clockwise',
              enable: true,
              animation: {
                enable: true,
                speed: 10
              }
            },
            number: {
              density: {
                enable: true,
                value_area: 800,
              },
              value: 10,
            },
            opacity: {
              value: 0.2,
            },
            shape: {
              options: {
                circle: [
                  {
                    fill: false,
                    particles: {
                      stroke: {
                        color: "#fff",
                        width: 1
                      }
                    }
                  }
                ],
                square: [
                  {
                    fill: false,
                    particles: {
                      stroke: {
                        color: "#fff",
                        width: 1
                      }
                    }
                  }
                ]
              },
              type: ["circle", "square"]
            },
            stroke: { color: "#fff", width: 0, opacity: 0.2 },
            size: {
              anim: { enable: false, size_min: 0.1, speed: 40, sync: false },
              random: { enable: true, minimumValue: 30 },
              value: 60
            }
          },
          detectRetina: true,
        }}
      />

      <div className={classes.Left}>
        <div className={classes.VideoCard} style={{ backgroundColor: '#FFFFFF' || colors[0] }}>
          <div className={classes.VideoContainer} style={{ width: videoWidth }} ref={videoContainerRef}>
            { end && videoWidth &&
              <VideoPlayer video="458819754" width={videoWidth} />
            }
          </div>
        </div>
      </div>

      {end && <motion.div className={classes.Right} style={{ color: colors[3] }}
        initial={{ x: -100, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        exit={{ x: 100, opacity: 0 }}
      >
        <div className={classes.TextContents}>
          <h4 className={classes.Title}>About this project</h4>
          <div className={classes.Details}>
            <p className={classes.Text}>
            Snaplark is the leading screenshot and GIF recording software, tailored to users most requested functionalities. Created by me and a team of professionals, the software functions with precision and finesse for a satisfactory result. With over a million medias uploaded. Snaplark has become the regular PC user’s favourite software. Taking into cognizance what traditional screenshot apps lack, Snaplark inculcates all the most requested features to give it a unique edge over others.
            </p>

            <h5 className={classes.DetailsTitle}>Unique Features:</h5>
            <ul className={classes.Ul}>
              <li className={classes.Li}>SaaS based systems</li>
              <li className={classes.Li}>High-end presised development technology</li>
              <li className={classes.Li}>Cloud based infrastructure systems</li>
              <li className={classes.Li}>Lightweight and easy user optimized.</li>
            </ul>
          </div>
        </div>

        <div className={classes.Buttons}>
          <a href="https://www.snaplark.com" target="_blank" className={classes.Link}>
            <BigButton style={{ color: colors[3], backgroundColor: colors[2] }} className={classes.Btn}>
              Visit Website
            </BigButton>
          </a>

          <p className={classes.EmailText}>hello@snaplark.com</p>
        </div>
      </motion.div>}
    </div>
  );
}

export default Snaplark;